import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IAcademicTerm, IAcademicTerms } from '../interfaces/academic-term';
import { IAcademicYear } from '../interfaces/academic-year';

@Injectable({
  providedIn: 'root',
})
export class AcademicTermService {
  constructor(private httpClient: HttpClient) {}

  createAcademicTerm(url: string, academicTermForm: any): Observable<IAcademicTerm> {
    return this.httpClient.post<IAcademicTerm>(url, academicTermForm, {
      headers: { accept: '*/*' },
    }) as Observable<IAcademicTerm>;
  }

  getAcademicTerms(url: string, filters: any): Observable<IAcademicTerms> {
    return this.httpClient.get<IAcademicTerms>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IAcademicTerms>;
  }

  editAcademicTerm(url: string, editForm: any): Observable<IAcademicTerm> {
    return this.httpClient.patch<IAcademicTerm>(url, editForm, {
      headers: { accept: '*/*' },
    }) as Observable<IAcademicTerm>;
  }
}
